const useFormInfo = ({ serviceRequest, t }) => {
  const {
    type: requestType,
    message,
    most_recent_role: mostRecentRole,
    desired_role: desiredRole,
    desired_goal: desiredGoal,
    desired_timeline: desiredTimeline,
    target_job_description: targetJobDescription,
    interview_with,
    interview_type,
    resume_document_id: resumeDocumentId,
    resume_document_name: resumeDocumentName,
  } = serviceRequest

  const interviewWith = interview_with.length > 0 ? interview_with : null
  const interviewType = interview_type.length > 0 ? interview_type : null

  const formResponses = {
    career_pivot_planning: [
      [
        t('CareerPivotPlanning.career_pivot_planning_form.notes_description'),
        message,
      ],
      [
        t('CareerPivotPlanning.career_pivot_planning_form.most_recent_role'),
        mostRecentRole,
      ],
      [
        t('CareerPivotPlanning.career_pivot_planning_form.desired_role'),
        desiredRole,
      ],
    ],
    job_search_strategy: [
      [t('job_search_strategy_form.desired_goal_label'), desiredGoal],
      [t('job_search_strategy_form.desired_timeline_label'), desiredTimeline],
      [t('job_search_strategy_form.message_label'), message],
    ],
    orientation_call: [
      [t('schedule_modal.coach_introduction.message_label'), message],
    ],
    mock_interview: [
      [
        t('mock_interview_form.target_job_description_label'),
        targetJobDescription,
      ],
      [t('mock_interview_form.interview_with_label'), interviewWith],
      [t('mock_interview_form.interview_type_label'), interviewType],
      [t('mock_interview_form.message_label'), message],
    ],
    retirement_support: [[t('retirement_support_form.message_label'), message]],
  }

  const attachments = {
    mock_interview: [{ name: resumeDocumentName, url: resumeDocumentId }],
  }

  const requestTypeFormResponses = formResponses[requestType] || []
  const requestTypeAttachments = attachments[requestType] || []
  const displaySetting =
    requestType.length > 0 || requestTypeAttachments.length > 0
      ? requestType != 'mock_interview'
        ? 1
        : 2
      : 0

  return {
    displaySetting,
    formResponses: requestTypeFormResponses,
    attachments: requestTypeAttachments,
  }
}

export default useFormInfo
